import { render, staticRenderFns } from "./AppBackground.vue?vue&type=template&id=33c03318&scoped=true&lang=pug&"
import script from "./AppBackground.vue?vue&type=script&lang=ts&"
export * from "./AppBackground.vue?vue&type=script&lang=ts&"
import style0 from "./AppBackground.vue?vue&type=style&index=0&id=33c03318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c03318",
  null
  
)

export default component.exports